import {
	AllTemplateConfigResponse,
	CreateTemplateConfigPayload,
	GetTemplatesByConfigPayload,
	GetTemplatesByConfigResponse,
} from 'types';
import { baseApi } from './axios';

const baseUrl = `${process.env.REACT_APP_API_URL}/templateConfig`;

export const getAllTemplateConfig = async (): Promise<AllTemplateConfigResponse> => {
	const response = await baseApi.get(`${baseUrl}/all`);
	return response.data;
};

export const fetchTemplatesByConfig = async (
	payload: GetTemplatesByConfigPayload,
): Promise<GetTemplatesByConfigResponse> => {
	const response = await baseApi.post(`${baseUrl}/fetchTemplatesByConfig`, payload);
	return response.data;
};
